import { whenGte } from '@execonline-inc/numbers';
import { fromNullable, just } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { findField } from '../../../../../../Resource/FormTemplates/Types';
import LearningCollectionEditStore from '../../../Edit/Store';
import { Section } from '../../../Types';
import BrowseAllButton from './BrowseAllButton';

interface Props {
  store: LearningCollectionEditStore;
}

const browseAllCollectionsLength = (sections: ReadonlyArray<Section>): number =>
  sections.filter((section) =>
    findField('browse_all', 'boolean', section.template.fields)
      .map((field) => field.value)
      .getOrElseValue(false),
  ).length;

const disabled = (sections: ReadonlyArray<Section>) =>
  just(browseAllCollectionsLength(sections)).andThen(whenGte(1)).isJust();

function NewBrowseAllSectionButton({ store }: Props) {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
    case 'load-error':
    case 'loading-for-deep-links':
    case 'ready-deep-links':
    case 'loading-for-invitations':
    case 'ready-invitations':
      return emptyFragment();
    case 'ready':
    case 'editing-details':
    case 'saving-details':
    case 'building':
    case 'choosing-learning-designs':
    case 'adding-learning-design':
    case 'deleting-section':
    case 'previewing':
    case 'sharing':
    case 'finishing':
    case 'finished':
    case 'updating':
    case 'edit-form-submission-error':
    case 'previewing-updating':
    case 'updating-product-license':
      const state = store.state;
      return fromNullable(
        state.learningCollectionEditFormResource.templates['create-browse-all-learning-design'],
      )
        .map(() => <BrowseAllButton store={store} disabled={disabled(store.sections)} />)
        .getOrElse(emptyFragment);
  }
}

export default observer(NewBrowseAllSectionButton);
